import styled from 'styled-components';

import { useGetTileDigestAutomator } from './data';
import LoadingComponent from '../../../../shared/LoadingComponent';
import AutomateForm from './AutomateForm.jsx';

const Wrapper = styled.div`
  padding: 24px 0 0;
`;

export default function Automate() {
  const { isLoading, data = {} } = useGetTileDigestAutomator();

  return (
    <Wrapper>
      {isLoading ? (
        <LoadingComponent />
      ) : (
        <AutomateForm
          automator={data.automator}
          scheduledMessage={data.scheduled_message}
        />
      )}
    </Wrapper>
  );
}
